import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { VehicleCoordinate } from '../types/VehicleCoordinate';

interface GoogleMapsAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GoogleMapsGeometry {
  location: {
    lat: number;
    lng: number;
  };
  location_type: string;
  viewport: {
    northeast: {
      lat: number;
      lng: number;
    };
    southwest: {
      lat: number;
      lng: number;
    };
  };
}

interface GoogleMapsResult {
  address_components: GoogleMapsAddressComponent[];
  formatted_address: string;
  geometry: GoogleMapsGeometry;
  place_id: string;
  types: string[];
}

interface GoogleMapsResponse {
  results: GoogleMapsResult[];
  status: string;
}

export const googleMapsApi = createApi({
  reducerPath: 'googleMapsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://maps.googleapis.com/maps/api/geocode/`,
  }),
  endpoints: builder => ({
    getLocation: builder.query<GoogleMapsResponse, Pick<VehicleCoordinate, 'latitude' | 'longitude'>>({
      query: arg => ({
        url: `json?latlng=${arg.latitude},${arg.longitude}&key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetLocationQuery } = googleMapsApi;
